import { userActions } from '../actions';

const getErrorMessageFromAction = (action): string => {
  const errorMessage =
    action?.payload?.error ||
    action?.payload?.message ||
    action?.error;
  return errorMessage || '';
};

const apiError = (store) => (next) => (action) => {
  console.debug(
    'middleware check for _ERROR in action.type ',
    action?.type,
  );
  if (action?.type?.endsWith('_ERROR')) {
    const errorMessage = getErrorMessageFromAction(action);

    if (action?.type !== 'ALERT_ERROR') {
      if (errorMessage) {
        console.debug(
          'middleware found _ERROR in action.type. action: ',
          action,
          errorMessage,
        );
        if (
          errorMessage.startsWith('Failed to authenticate token.') ||
          errorMessage.startsWith('No token provided.') ||
          errorMessage.startsWith('Socket Incorrect Token')
        ) {
          console.error(errorMessage);
          // if expire don't clear local storage (user), and localStorage (viewingTicketId)
          store.dispatch(userActions.logout(true, false));
        }
      }
    } else {
      // replace message from Failed to authenticate token to Session expired
      // note: if want to return nothing then call return; (so it doesn't go to next(action))
      if (errorMessage.startsWith('Failed to authenticate token.')) {
        return next({
          ...action,
          payload: { message: `Session expired` },
        });
      }
    }
  }
  return next(action);
};
export default apiError;
